import { track } from '../../analytics/events';


export const choiceAnalytics = () => ({
  informedDelivery: ({ target: { checked } }) => track('ElementClicked', {
    webElement: {
      elementType: 'CHECKBOX',
      text: 'Informed Delivery',
    },
    actionOutcome: `TOGGLE_${checked ? 'ON' : 'OFF'}`,
  }),
});
export const desktopAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'MOVE_COMBINED',
      formName: 'MOVE_COMBINED',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    businessName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'business-name',
        fieldLabel: 'Business Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    /**
     * @param {String} num - Business Alias number
     */
    businessAlias: (num) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: `business-alias-${num}`,
        fieldLabel: `Business Alias ${num}`,
      },
      formContext: {
        formName: 'BUSINESS_ALIASES',
      },
    }),
    firstName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'first-name',
        fieldLabel: 'First Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    lastName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'last-name',
        fieldLabel: 'Last Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    email: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email',
        fieldLabel: 'Email Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    emailConfirm: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email-confirm',
        fieldLabel: 'Confirm Email Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    phone: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'PHONE',
        fieldName: 'phone',
        fieldLabel: 'Phone Number',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    phoneType: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'phone-type',
        fieldLabel: 'Phone Type',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    startDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-start-date',
        fieldLabel: 'Start Forwarding',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    stopDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-stop-date',
        fieldLabel: 'End Forwarding',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    getStarted: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Get Started',
      },
      actionOutcome: 'SCROLLED',
    }),
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    businessModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'BUSINESS_MODAL_CLOSED',
    }),
    businessAliases: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Business Aliases',
      },
      actionOutcome: `${on ? 'SHOW' : 'HIDE'}`,
    }),
    emailOptOutModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'click here',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_OPENED',
    }),
    emailOptOutModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Close',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_CLOSED',
    }),
    forwardType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'FORWARD_TYPE',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    informedDelivery: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Informed Delivery',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});

export const mobileAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'MOVE_COMBINED',
      formName: 'MOVE_COMBINED',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    businessName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'business-name',
        fieldLabel: 'Business Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    /**
     * @param {String} num - Business Alias number
     */
    businessAlias: (num) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: `business-alias-${num}`,
        fieldLabel: `Business Alias ${num}`,
      },
      formContext: {
        formName: 'BUSINESS_ALIASES',
      },
    }),
    firstName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'first-name',
        fieldLabel: 'First Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    lastName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'last-name',
        fieldLabel: 'Last Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    email: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email',
        fieldLabel: 'Email Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    emailConfirm: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email-confirm',
        fieldLabel: 'Confirm Email Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    phone: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'PHONE',
        fieldName: 'phone',
        fieldLabel: 'Phone Number',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    phoneType: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'phone-type',
        fieldLabel: 'Phone Type',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    startDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-start-date',
        fieldLabel: 'Start Forwarding',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    stopDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-stop-date',
        fieldLabel: 'End Forwarding',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    businessMultipleAddresses: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-multiple-addresses',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    // mobile "Disclaimer" click event
    getStarted: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Get Started',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    // other mobile MoveCombined click events
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    businessModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'BUSINESS_MODAL_CLOSED',
    }),
    businessAliases: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Business Aliases',
      },
      actionOutcome: `${on ? 'SHOW' : 'HIDE'}`,
    }),
    emailOptOutModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'click here',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_OPENED',
    }),
    emailOptOutModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Close',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_CLOSED',
    }),
    optInReminder: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Opt In Reminder Email',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    forwardType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'FORWARD_TYPE',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    informedDelivery: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Informed Delivery',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
    tooltipMoveType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-move-type',
      },
      actionOutcome: '',
    }),
    tooltipInformation: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-name',
      },
      actionOutcome: '',
    }),
    tooltipForwardType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-type',
      },
      actionOutcome: '',
    }),
    tooltipForwardStartDate: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-start-date',
      },
      actionOutcome: '',
    }),
    tooltipOldAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-old-address',
      },
      actionOutcome: '',
    }),
    tooltipNewAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-new-address',
      },
      actionOutcome: '',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});
